import { render, staticRenderFns } from "./ModelChat.vue?vue&type=template&id=0bcafaf6&scoped=true&"
import script from "./ModelChat.vue?vue&type=script&lang=js&"
export * from "./ModelChat.vue?vue&type=script&lang=js&"
import style0 from "./ModelChat.vue?vue&type=style&index=0&id=0bcafaf6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcafaf6",
  null
  
)

export default component.exports